import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '@/store/store';
import { setCompany } from '../store/slices/companySlice';

import Tooltip from './company/tooltip';

const Skeleton = () => (
  <div className="mt-2">
    <div className="overflow-y-auto">
      {Array.from({ length: 8 }).map((_, index) => (
        <div
          key={index}
          className="py-1 h-5 w-full bg-gray-300 animate-pulse rounded-md mb-2"></div>
      ))}
    </div>
  </div>
);

/**
 * Renders a list of companies with an option to select one.
 * Companies that are not integrated with the necessary services (e-conomic, Dinero, or Billy) are displayed in a grayed-out style and are not clickable.
 * When hovering over a non-integrated company, a tooltip appears explaining the need for integration.
 *
 */

const Company = () => {
  const dispatch = useAppDispatch();
  const { companies, status, currentCompany } = useSelector(
    (state: RootState) => state.company
  );

  const handleChangeCompany = (companyId: number) => {
    dispatch(setCompany(companyId));
  };

  if (status === 'loading') {
    return <Skeleton />;
  }

  const getWrapperClasses = () => {
    if (companies.length === 1) {
      return 'max-h-none overflow-visible';
    }
    if (companies.length <= 3) {
      return 'max-h-fit overflow-visible';
    }
    return 'max-h-60 overflow-y-auto';
  };

  return (
    <div className="mt-2">
      <div className={`scroll ${getWrapperClasses()}`}>
        {companies.map((company) => {
          const isEnable =
            company?.hasIntegrationWithConnectedStatus &&
            company?.isBankInfoFilled;

          const companyElement = (
            <div
              key={company.id}
              className={`py-1 text-left text-base font-jostRegular cursor-pointer
                ${currentCompany?.id === company?.id ? 'font-extrabold' : ''} 
                ${isEnable ? '' : 'pointer-events-none text-gray-400'}
                hover:font-extrabold`}
              onClick={() => handleChangeCompany(company.id)}>
              {company.name}
            </div>
          );

          return isEnable ? (
            companyElement
          ) : (
            <Tooltip
              key={company.id}
              content="Integrer venligst din virksomhed for at se forfaldne fakturaer.">
              {companyElement}
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};

export default Company;
